import env from './env';
// import AsyncStorage from '@react-native-community/async-storage';
const Get = {
  gamelist: () => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem('user');
      if (user) {
        fetch(env.Url + 'game?api_token=' + JSON.parse(user).api_token, {
          method: 'GET',
          headers: {
            Accept: 'application/json',
          },
        })
          .then(res => res.json())
          .then(res => {
            resolve(res);
          });
      }
    });
  },
  PlayHistory: type => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem('user');
      if (user) {
        console.log(
          env.Url +
            'bedding?api_token=' +
            JSON.parse(user).api_token +
            '&type=' +
            type,
        );
        fetch(
          env.Url +
            'bedding?api_token=' +
            JSON.parse(user).api_token +
            '&type=' +
            type,
          {
            method: 'GET',
            headers: {
              Accept: 'application/json',
            },
          },
        )
          .then(res => res.json())
          .then(res => {
            resolve(res);
          });
      }
    });
  },
  slider: () => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem('user');
      if (user) {
        fetch(env.Url + 'slider?api_token=' + JSON.parse(user).api_token, {
          method: 'GET',
          headers: {
            Accept: 'application/json',
          },
        })
          .then(res => res.json())
          .then(res => {
            resolve(res);
          });
      }
    });
  },
  Wallet: data => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem('user');
      if (user) {
        fetch(
          env.Url +
            'wallet?api_token=' +
            JSON.parse(user).api_token +
            '&type=' +
            (data ? data : ''),
          {
            method: 'GET',
            headers: {
              Accept: 'application/json',
            },
          },
        )
          .then(res => res.json())
          .then(res => {
            resolve(res);
          });
      }
    });
  },

  Method: () => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem('user');
      if (user) {
        fetch(
          env.Url + 'payment/method?api_token=' + JSON.parse(user).api_token,
          {
            method: 'GET',
            headers: {
              Accept: 'application/json',
            },
          },
        )
          .then(res => res.json())
          .then(res => {
            resolve(res);
          });
      }
    });
  },

  Page: () => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem('user');
      if (user) {
        fetch(env.Url + 'page?api_token=' + JSON.parse(user).api_token, {
          method: 'GET',
          headers: {
            Accept: 'application/json',
          },
        })
          .then(res => res.json())
          .then(res => {
            resolve(res);
          });
      }
    });
  },

  Upi: () => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem('user');
      if (user) {
        console.log(env.Url + 'upi?api_token=' + JSON.parse(user).api_token);
        fetch(env.Url + 'upi?api_token=' + JSON.parse(user).api_token, {
          method: 'GET',
          headers: {
            Accept: 'application/json',
          },
        })
          .then(res => res.json())
          .then(res => {
            resolve(res);
          });
      }
    });
  },

  Setting: () => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem('user');
      if (user) {
        fetch(env.Url + 'setting?api_token=' + JSON.parse(user).api_token, {
          method: 'GET',
          headers: {
            Accept: 'application/json',
          },
        })
          .then(res => res.json())
          .then(res => {
            resolve(res);
          });
      }
    });
  },

  Result: version => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem('user');
      if (user) {
        fetch(
          env.Url +
            'result?api_token=' +
            JSON.parse(user).api_token +
            '&version=' +
            (version ? version : ''),
          {
            method: 'GET',
            headers: {
              Accept: 'application/json',
            },
          },
        )
          .then(res => res.json())
          .then(res => resolve(res));
      }
    });
  },

  SendMessage: data => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem('user');
      if (user) {
        fetch(
          env.Url +
            'send/message?api_token=' +
            JSON.parse(user).api_token +
            '&message=' +
            data,
          {
            method: 'GET',
            headers: {
              Accept: 'application/json',
            },
          },
        )
          .then(res => res.json())
          .then(res => resolve(res));
      }
    });
  },

  time: data => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem('user');
      console.log(
        env.Url +
          'harf?api_token=' +
          (user ? JSON.parse(user).api_token : '') +
          '&url=game/time',
      );
      fetch(
        env.Url +
          'harf?api_token=' +
          (user ? JSON.parse(user).api_token : '') +
          '&url=game/time',
        {
          method: 'Get',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
        },
      )
        .then(res => res.json())
        .then(res => {
          console.log(res);
          resolve(res);
        });
    });
  },

  result: id => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem('user');
      fetch(
        env.Url +
          'harf?api_token=' +
          (user ? JSON.parse(user).api_token : '') +
          '&url=result?id=' +
          (id ? id : ''),
        {
          method: 'Get',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
        },
      )
        .then(res => res.json())
        .then(res => {
          resolve(res);
        });
    });
  },

  results: () => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem('user');
      console.log(
        env.Url +
          'harf?api_token=' +
          (user ? JSON.parse(user).api_token : '') +
          '&url=my/result',
      );
      fetch(
        env.Url +
          'harf?api_token=' +
          (user ? JSON.parse(user).api_token : '') +
          '&url=my/result',
        {
          method: 'Get',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
        },
      )
        .then(res => res.json())
        .then(res => {
          resolve(res);
        });
    });
  },

  bedding: () => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem('user');
      console.log(
        env.Url +
          'harf?api_token=' +
          (user ? JSON.parse(user).api_token : '') +
          '&url=bedding?limit=true',
      );
      fetch(
        env.Url +
          'harf?api_token=' +
          (user ? JSON.parse(user).api_token : '') +
          '&url=bedding?limit=4&user_id=' +
          (user ? JSON.parse(user).id : ''),
        {
          method: 'Get',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
        },
      )
        .then(res => res.json())
        .then(res => {
          resolve(res);
        });
    });
  },
};
export default Get;
